import React from 'react';
import { useInView } from '@/hooks/useInView';

const clean = (w) => w.replace(/[^\w'’-]/g, '').toLowerCase();

/**
 * Masked word-by-word rise. `accent` marks one word (or several, space
 * separated, matched in order) as the serif italic gradient accent; an accent
 * run that ends the headline keeps its trailing punctuation inside the accent.
 */
export function WordReveal({
  as: As = 'h1',
  text,
  className = '',
  accent,
  baseDelay = 0,
  perWordDelay = 55,
  'data-testid': testId,
}) {
  const [ref, inView] = useInView({ threshold: 0.2 });
  const words = String(text).split(' ');
  const accentWords = accent ? String(accent).split(' ').map(clean).filter(Boolean) : [];

  // Find the first run of consecutive words matching the accent phrase.
  let start = -1;
  if (accentWords.length) {
    for (let i = 0; i <= words.length - accentWords.length; i += 1) {
      if (accentWords.every((a, j) => clean(words[i + j]) === a)) { start = i; break; }
    }
  }
  const isAccent = (i) => start >= 0 && i >= start && i < start + accentWords.length;

  return (
    <As ref={ref} data-testid={testId} className={`${className} ${inView ? 'in-view' : ''}`}>
      {words.map((w, i) => (
        <React.Fragment key={i}>
          <span className="word">
            <span
              className={isAccent(i) ? 'nd-accent' : undefined}
              style={{ transitionDelay: `${baseDelay + i * perWordDelay}ms` }}
            >
              {w}
            </span>
          </span>
          {i < words.length - 1 ? ' ' : null}
        </React.Fragment>
      ))}
    </As>
  );
}
